import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
const DRA_LOGO = 'https://cdn.magicpatterns.com/uploads/wkgK3TfUfV2kt1gG4bGoYo/logo_Dra_Ysalismar.png';
const PROFEM_LOGO = 'https://cdn.magicpatterns.com/uploads/dVddGeVW64T3Smy2i85CP7/Logo_Centro_medico_Especializado_Profem.jpg';
export function Guarantee() {
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div className="rounded-2xl p-8 md:p-12 shadow-xl" style={{
        background: 'linear-gradient(135deg, #F5EBDD 0%, #DCCFEA 100%)'
      }} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-109">
          <div className="flex justify-center mb-6" data-id="element-110">
            <div className="bg-white/60 rounded-full p-5" data-id="element-111">
              <ShieldIcon className="w-12 h-12 text-heading" data-id="element-112" />
            </div>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-heading text-center mb-6" data-id="element-113">
            Respaldada por profesionales de la salud
          </h2>

          <p className="text-body text-lg leading-relaxed text-center max-w-2xl mx-auto mb-10" data-id="element-114">
            Esta guía fue revisada y avalada por especialistas en salud femenina
            para garantizar que el contenido sea educativo, responsable y útil
            para toda mujer.
          </p>

          {/* Logos */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 items-center mb-10" data-id="element-115">
            <div className="flex flex-col items-center text-center" data-id="element-116">
              <div className="bg-white p-4 rounded-xl mb-3 h-32 flex items-center justify-center w-full shadow-sm" data-id="element-117">
                <img src={DRA_LOGO} alt="Dra. Ysailis Martínez" className="max-h-28 max-w-full object-contain" data-id="element-118" />
              </div>
              <p className="font-semibold text-heading" data-id="element-119">
                Dra. Ysailis Martinez
              </p>
              <a href="https://instagram.com/draysailismartinez" target="_blank" rel="noopener noreferrer" className="text-sm text-button hover:underline" data-id="element-120">
                📲 @draysailismartinez
              </a>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-121">
              <div className="bg-white p-4 rounded-xl mb-3 h-32 flex items-center justify-center w-full shadow-sm" data-id="element-122">
                <img src={PROFEM_LOGO} alt="Centro Médico Especializado Profem" className="max-h-28 max-w-full object-contain" data-id="element-123" />
              </div>
              <p className="font-semibold text-heading" data-id="element-124">
                Centro Médico Especializado Profem
              </p>
              <a href="https://instagram.com/profemm.ccs" target="_blank" rel="noopener noreferrer" className="text-sm text-button hover:underline" data-id="element-125">
                📲 @profemm.ccs
              </a>
            </div>
          </div>

          {/* Quote box */}
          <div className="rounded-xl p-5 md:p-6 text-center" style={{
          background: '#EFCFD3'
        }} data-id="element-126">
            <p className="text-body text-base md:text-lg italic leading-relaxed mb-3" data-id="element-127">
              "Recomendamos esta guía como recurso educativo para mujeres que
              buscan información clara y confiable sobre su salud íntima."
            </p>
            <p className="font-semibold text-heading text-sm md:text-base" data-id="element-128">
              — Dra. Ysailis Martinez y Centro Médico Especializado Profem
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}